// The Curve's logarithmic axis (UI-6), apart from the component so that the
// arithmetic runs on Node in tests/admin without bundling the chart library.

/** Decades that hold every positive value: [1 000, 10 000, …]. Zeros and
 * gaps are ignored — a logarithm has no place for them — and an axis with
 * nothing to hold is one decade. */
export function logTicks(values: (number | null | undefined)[]): number[] {
  const positive = values.filter((value): value is number => typeof value === "number" && value > 0);
  if (positive.length === 0) return [1, 10];
  const low = Math.floor(Math.log10(Math.min(...positive)));
  let high = Math.ceil(Math.log10(Math.max(...positive)));
  if (high <= low) high = low + 1;
  const ticks: number[] = [];
  for (let power = low; power <= high; power += 1) ticks.push(10 ** power);
  return ticks;
}
